import { render, staticRenderFns } from "./SimpleBar.vue?vue&type=template&id=cc249ace&scoped=true"
import script from "./SimpleBar.vue?vue&type=script&lang=js"
export * from "./SimpleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc249ace",
  null
  
)

export default component.exports